(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athletes-swiper"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

    const ensureSwiperCss = () => {
      if (document.querySelector('link[data-athletes-swiper-css]')) return;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = SWIPER_CSS;
      link.setAttribute('data-athletes-swiper-css', '');
      document.head.appendChild(link);
    };

    const ensureSwiperJs = () => {
      if (window.Swiper) return Promise.resolve();
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = SWIPER_JS;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Swiper load failed'));
        document.head.appendChild(script);
      });
    };

    const initAthletesSwiper = async (section) => {
      const root = section.querySelector('[data-athletes-swiper-root]');
      if (!root || root.dataset.athletesSwiperReady === 'true') return;

      ensureSwiperCss();
      try {
        await ensureSwiperJs();
      } catch {
        return;
      }

      const slideW = parseInt(root.dataset.slideWidth, 10) || 325;
      const gap = parseInt(root.dataset.slideGap, 10) || 32;
      const mobileGap = 8;

      root.style.setProperty('--athletes-mobile-gap', `${mobileGap}px`);
      root.style.setProperty('--athletes-slide-width', `${slideW}px`);
      root.style.setProperty('--athletes-slide-gap', `${gap}px`);

      const prev = section.querySelector('[data-athletes-swiper-prev]');
      const next = section.querySelector('[data-athletes-swiper-next]');

      const config = {
        slidesPerView: 'auto',
        spaceBetween: mobileGap,
        centeredSlides: false,
        centerInsufficientSlides: false,
        slidesOffsetBefore: Math.round(mobileGap * 0.6),
        slidesOffsetAfter: Math.round(mobileGap * 0.95),
        freeMode: false,
        watchOverflow: false,
        grabCursor: true,
        resistanceRatio: 0.65,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        longSwipes: false,
        longSwipesRatio: 0.12,
        breakpoints: {
          990: {
            centeredSlides: false,
            centerInsufficientSlides: false,
            spaceBetween: gap,
            slidesOffsetBefore: Math.round(gap * 0.45),
            slidesOffsetAfter: Math.round(gap * 0.9),
            longSwipesRatio: 0.12,
          },
        },
      };

      if (prev && next) {
        config.navigation = { prevEl: prev, nextEl: next };
      }

      const swiper = new window.Swiper(root, config);
      root.dataset.athletesSwiperReady = 'true';
      root._athletesSwiperInstance = swiper;

      const scheduleUpdate = () => {
        requestAnimationFrame(() => {
          swiper.update();
        });
      };

      scheduleUpdate();
      requestAnimationFrame(scheduleUpdate);

      let resizeTimer;
      const onResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(scheduleUpdate, 120);
      };
      window.addEventListener('resize', onResize);
      window.addEventListener('orientationchange', scheduleUpdate);

      root._athletesSwiperViewportCleanup = () => {
        window.removeEventListener('resize', onResize);
        window.removeEventListener('orientationchange', scheduleUpdate);
        clearTimeout(resizeTimer);
      };
    };

    const boot = () => {
      document.querySelectorAll('[data-athletes-swiper]').forEach((section) => {
        initAthletesSwiper(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target;
      if (!(container instanceof HTMLElement)) return;
      const section = container.querySelector('[data-athletes-swiper]');
      if (section) initAthletesSwiper(section);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const container = event.target;
      if (!(container instanceof HTMLElement)) return;
      const section = container.querySelector('[data-athletes-swiper]');
      if (!section) return;
      const root = section.querySelector('[data-athletes-swiper-root]');
      if (
        root &&
        root._athletesSwiperInstance &&
        typeof root._athletesSwiperInstance.destroy === 'function'
      ) {
        if (typeof root._athletesSwiperViewportCleanup === 'function') {
          root._athletesSwiperViewportCleanup();
          delete root._athletesSwiperViewportCleanup;
        }
        root._athletesSwiperInstance.destroy(true, true);
        delete root._athletesSwiperInstance;
        delete root.dataset.athletesSwiperReady;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doctors-swiper"] && !Shopify.designMode) return;
  try {
    
  (() => {})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutri-real-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-nutri-real-results]').forEach((root) => {
      const cards = root.querySelectorAll('.nutri-real-results__card');
      const dots = root.querySelectorAll('.nutri-real-results__dot');
      if (!cards.length) return;

      let activeIndex = 0;
      let timerId;
      const INTERVAL = 5000;

      const setActive = (index) => {
        activeIndex = index;
        cards.forEach((card, i) => {
          card.classList.toggle('nutri-real-results__card--active', i === index);
        });
        dots.forEach((dot, i) => {
          const isActive = i === index;
          dot.classList.toggle('nutri-real-results__dot--active', isActive);
          dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const next = () => {
        const nextIndex = (activeIndex + 1) % cards.length;
        setActive(nextIndex);
      };

      const start = () => {
        stop();
        timerId = window.setInterval(next, INTERVAL);
      };

      const stop = () => {
        if (timerId) {
          window.clearInterval(timerId);
          timerId = undefined;
        }
      };

      cards.forEach((card, index) => {
        card.addEventListener('mouseenter', stop);
        card.addEventListener('mouseleave', start);
        card.addEventListener('click', () => {
          setActive(index);
          start();
        });
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          setActive(index);
          start();
        });
      });

      setActive(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

    const ensureSwiperCss = () => {
      if (document.querySelector('link[data-ugc-swiper-css]')) return;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = SWIPER_CSS;
      link.setAttribute('data-ugc-swiper-css', '');
      document.head.appendChild(link);
    };

    const ensureSwiperJs = () => {
      if (window.Swiper) return Promise.resolve();
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = SWIPER_JS;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Swiper load failed'));
        document.head.appendChild(script);
      });
    };

    const initSwiper = (root) => {
      const el = root.querySelector('[data-ugc-swiper-root]');
      if (!el || el.dataset.ugcSwiperReady === 'true') return;

      const slideW = parseInt(el.dataset.slideWidth, 10) || 244;
      const gap = parseInt(el.dataset.slideGap, 10) || 16;
      const mobileGap = Math.max(8, Math.min(gap, 12));
      el.style.setProperty('--ugc-slide-width', `${slideW}px`);
      el.style.setProperty('--ugc-slide-gap', `${gap}px`);
      el.style.setProperty('--ugc-mobile-gap', `${mobileGap}px`);

      const prev = root.querySelector('[data-ugc-swiper-prev]');
      const next = root.querySelector('[data-ugc-swiper-next]');
      const config = {
        slidesPerView: 'auto',
        spaceBetween: mobileGap,
        centeredSlides: true,
        centerInsufficientSlides: true,
        freeMode: false,
        watchOverflow: false,
        grabCursor: true,
        resistanceRatio: 0.85,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        longSwipes: true,
        longSwipesRatio: 0.2,
        breakpoints: {
          990: {
            centeredSlides: false,
            centerInsufficientSlides: false,
            spaceBetween: gap,
            freeMode: {
              enabled: true,
              momentum: true,
              momentumRatio: 0.88,
              minimumVelocity: 0.02,
            },
            longSwipesRatio: 0.12,
          },
        },
      };

      if (prev && next) {
        config.navigation = {
          prevEl: prev,
          nextEl: next,
        };
      }

      const swiper = new window.Swiper(el, config);
      el.dataset.ugcSwiperReady = 'true';
      el._ugcSwiperInstance = swiper;

      const scheduleUpdate = () => {
        requestAnimationFrame(() => {
          swiper.update();
        });
      };
      scheduleUpdate();
      requestAnimationFrame(scheduleUpdate);

      const onOrientation = () => scheduleUpdate();
      let resizeTimer;
      const onResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(scheduleUpdate, 120);
      };
      window.addEventListener('orientationchange', onOrientation);
      window.addEventListener('resize', onResize);
      el._ugcSwiperViewportCleanup = () => {
        window.removeEventListener('orientationchange', onOrientation);
        window.removeEventListener('resize', onResize);
        clearTimeout(resizeTimer);
      };

    };

    const stopVideo = (media) => {
      const video = media.querySelector('video');
      const placeholder = media.querySelector('[data-ugc-placeholder]');
      const playButton = media.querySelector('[data-ugc-play]');
      if (!video) return;
      media.classList.remove('is-playing');
      video.pause();
      video.controls = false;
      if (placeholder) {
        placeholder.hidden = false;
        placeholder.style.removeProperty('visibility');
        placeholder.style.removeProperty('opacity');
      }
      if (playButton) playButton.hidden = false;
    };

    const initVideos = (section) => {
      const medias = Array.from(section.querySelectorAll('[data-ugc-media]'));

      medias.forEach((media) => {
        const button = media.querySelector('[data-ugc-play]');
        const video = media.querySelector('video');
        if (!video) return;

        const playHandler = () => {
          medias.forEach((other) => {
            if (other !== media) stopVideo(other);
          });
          video.controls = true;
          video.play().catch(() => {});
        };

        if (button) {
          button.addEventListener('click', playHandler);
        }

        video.addEventListener('play', () => {
          medias.forEach((other) => {
            if (other !== media) stopVideo(other);
          });
          media.classList.add('is-playing');
          if (button) button.hidden = true;
        });

        video.addEventListener('playing', () => {
          media.classList.add('is-playing');
          if (button) button.hidden = true;
        });

        video.addEventListener('pause', () => {
          media.classList.remove('is-playing');
          if (button) button.hidden = false;
          video.controls = false;
        });

        video.addEventListener('ended', () => {
          media.classList.remove('is-playing');
          if (button) button.hidden = false;
          video.controls = false;
        });
      });
    };

    const initSection = async (section) => {
      const swiperRoot = section.querySelector('[data-ugc-swiper-root]');
      if (swiperRoot) {
        ensureSwiperCss();
        try {
          await ensureSwiperJs();
          initSwiper(section);
        } catch {
          return;
        }
      }
      initVideos(section);
    };

    const boot = () => {
      document.querySelectorAll('[data-ugc]').forEach((section) => {
        initSection(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target;
      if (!(container instanceof HTMLElement)) return;
      const section = container.querySelector('[data-ugc]');
      if (section) initSection(section);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const container = event.target;
      if (!(container instanceof HTMLElement)) return;
      const section = container.querySelector('[data-ugc]');
      if (!section) return;
      const el = section.querySelector('[data-ugc-swiper-root]');
      if (el && el._ugcSwiperInstance && typeof el._ugcSwiperInstance.destroy === 'function') {
        if (typeof el._ugcSwiperViewportCleanup === 'function') {
          el._ugcSwiperViewportCleanup();
          delete el._ugcSwiperViewportCleanup;
        }
        el._ugcSwiperInstance.destroy(true, true);
        delete el._ugcSwiperInstance;
        delete el.dataset.ugcSwiperReady;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
